$(document).ready(function () {
  $(".product-item_swatch_bubble").click(function () {
    $(".product-item_swatch_bubble").removeClass("active");
    $(this).addClass("active");

    var currentColor = $(this).attr("data-color");
    var fullTitle = currentColor;

    var currentColorTitle = $(this).attr("data-color-title");

    $(this)
      .closest(".product-item__inner")
      .find(".produc-items__colorlab")
      .html(currentColorTitle);

    $(this)
      .closest(".product-item_meta_box")
      .find(".product-item-swatch_config")
      .each(function () {
        fullTitle = fullTitle + "-" + $(this).attr("data-value");
      });

    // console.log(fullTitle, 'FULL TITLE');

    var currentSrc = $(this)
      .closest(".product-item_meta_box")
      .find('.prod-variants__config[data-title="' + fullTitle + '"]')
      .attr("data-img");
    var currentId = $(this)
      .closest(".product-item_meta_box")
      .find('.prod-variants__config[data-title="' + fullTitle + '"]')
      .attr("data-id");

    $(this)
      .closest(".product-item__inner")
      .find(".product-items-config__js")
      .attr("value", currentId);

    var $inner = $(this).closest(".product-item__inner");
    var $imageLink = $inner.find(".product-item__image-link");
    var $img = $inner.find(".product-item__image--one img");

    // Update image
    $img.attr("src", currentSrc);
    $img.attr("srcset", currentSrc);

    // Get and update href
    var oldUrl = $imageLink.attr("href");

    // Use URL object for easier manipulation
    var url = new URL(oldUrl, window.location.origin);
    url.searchParams.set("variant", currentId); // Add or update variant param

    // Set updated URL
    $imageLink.attr("href", url.pathname + url.search);
  });

  $(".collections-grid-nav_block").click(function () {
    $(".collections-grid-nav_block").removeClass("active");
    $(this).addClass("active");
    var currentId = $(this).attr("data-id");
    $(".collection-grid").addClass("hidden");
    $('.collection-grid[data-id="' + currentId + '"]').removeClass("hidden");

    var currentTitle = $(this).find("p").html();
    $(".mp_section").hide();
    if (currentTitle == "Shop All" || currentTitle == "Find Your Perfect Gift") {
      $(".mp_section").show();
    }

    $(this)
      .closest(".collection-grid_outer")
      .find(".collection-grid_car")
      .addClass("hidden");
    $(this)
      .closest(".collection-grid_outer")
      .find('.collection-grid_car[data-id="' + currentId + '"]')
      .removeClass("hidden");
  });

  $(".cgcq_option_select").click(function () {
    $(this)
      .closest(".cgcq_option_select_Grid")
      .find(".cgcq_option_select")
      .removeClass("active");
    $(this).addClass("active");

    var productId = $(this).attr("data-product-id");

    var currentTitle = $(this).attr("data-title-for");
    $(this)
      .closest(".cgcq_option")
      .find(".cgcq_option__val")
      .html(currentTitle);

    var fullTitle = "";
    $(this)
      .closest(".cgcq_config_inner")
      .find(".cgcq_option")
      .each(function () {
        var currentTitle = $(this)
          .find(".cgcq_option_select.active")
          .attr("data-title");
        fullTitle = fullTitle + "-" + currentTitle;
      });

    fullTitle = fullTitle.substring(1);

    // console.log(fullTitle);

    var currentId = $(
      '.cgcq_popup_config[data-product-id="' +
      productId +
      '"][data-title="' +
      fullTitle +
      '"]'
    ).attr("data-id");
    var currentImg = $(
      '.cgcq_popup_config[data-product-id="' +
      productId +
      '"][data-title="' +
      fullTitle +
      '"]'
    ).attr("data-img");

    $(this)
      .closest(".cgcq_inner")
      .find(".cgcq_main_img")
      .attr("src", currentImg);
    $(this).closest(".cgcq_variant_box").attr("data-id", currentId);

    // console.log("currentImg");
  });

  $(".cgcq_option_label").click(function () {
    $(this).closest(".cgcq_variant_box").toggleClass("hidded");
  });

  function setPopupImages() {
    $(".cgcq_variant_box").each(function () {
      var productId = $(this).attr("data-product-id");
      $(this)
        .find(".cgcq_option_select.color")
        .each(function () {
          var fullTitle = $(this).attr("data-title");
          $(this)
            .closest(".cgcq_variant_box")
            .find(".cgcq_option_select.size.active")
            .each(function () {
              var currentTitle = $(this).attr("data-title");
              fullTitle = fullTitle + "-" + currentTitle;
            });
          var currentImg = $(
            '.cgcq_popup_config[data-product-id="' +
            productId +
            '"][data-title="' +
            fullTitle +
            '"]'
          ).attr("data-img");

          //   console.log(fullTitle, "FULL TITLE");
          //   console.log(currentImg, "CURREN IMAGE");
          $(this).find("img").attr("src", currentImg);
        });
    });
  }

  setPopupImages();

  $(".cgcq_atc_btn").click(function (evt) {
    evt.preventDefault();
    var i = 0;
    var currentLastId;
    $(this)
      .closest(".cgcq_inner")
      .find(".cgcq_variant_box")
      .each(function () {
        i++;
        if (i == 1) {
          var currentId = $(this).attr("data-id");
          $(this)
            .closest(".cgcq_inner")
            .find(".product-items-config__js_first")
            .attr("value", currentId);
        } else {
          currentLastId = $(this).attr("data-id");
        }
      });

    data = {
      id: currentLastId,
      quantity: 1,
    };

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () { },
      error: function () { },
    });

    var thisEl = $(this);
    setTimeout(function () {
      thisEl
        .closest(".cgcq_inner")
        .find(".cgcq_atc_btnSubmitting")
        .trigger("click");
      $(".collection-grid-card__quickadd").hide();
    }, 1000);
  });

  $(".cgcq_close").click(function () {
    $(".collection-grid-card__quickadd").hide();
  });

  $(".product-item__quick_add").click(function () {
    var currentId = $(this).attr("data-id");
    // console.log(currentId, "CURRENT ID");
    $('.collection-grid-card__quickadd[data-id="' + currentId + '"]').css(
      "display",
      "flex"
    );
  });

  // Story icon drag-scroll
  $(".story-icons-enabled").each(function () {
    let $container = $(this);
    let $nav = $container.find(".collection-grid_nav");
    if (!$nav.length) return;
    let isDown = false, startX = 0, scrollStart = 0, hasDragged = false;

    function checkOverflow() {
      let overflowing = $nav[0].scrollWidth > $container[0].clientWidth;
      $container.toggleClass("drag-scroll-active", overflowing);
      return overflowing;
    }

    $container.on("mousedown", function (e) {
      if (!checkOverflow()) return;
      isDown = true;
      hasDragged = false;
      startX = e.pageX;
      scrollStart = $container.scrollLeft();
    });
    $container.on("mousemove", function (e) {
      if (!isDown) return;
      let dx = e.pageX - startX;
      if (Math.abs(dx) > 3) hasDragged = true;
      $container.scrollLeft(scrollStart - dx);
    });
    $container.on("mouseup mouseleave", function () { isDown = false; });
    $nav.on("click", function (e) {
      if (hasDragged) { e.stopPropagation(); hasDragged = false; }
    });

    let resizeTimer;
    $(window).on("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(checkOverflow, 150);
    });
    checkOverflow();
  });
});
